import type { StockStatus } from '@jouzen/ecom-components/v3/types/stockStatus';

import type Selections from '../_steps/enums/SizeStep';
import type WizStepId from '../_steps/enums/WizStepId';
import { useChargerButtonDisabled } from './useChargerButtonDisabled';
import { useRingsButtonDisabled } from './useRingsButtonDisabled';

export interface UseButtonDisabledProps {
  currentStep: WizStepId;
  isAccessory: boolean;
  isLoadingPdpData: boolean;
  size: {
    value: string;
    isValid: boolean;
  };
  sizingSelector: Selections;
  stockStatus: StockStatus;
}

export const useButtonDisabled = ({
  currentStep,
  isAccessory,
  isLoadingPdpData,
  size,
  sizingSelector,
  stockStatus,
}: UseButtonDisabledProps) => {
  const ringsButtonDisabled = useRingsButtonDisabled({
    currentStep,
    isAccessory,
    isLoadingPdpData,
    size,
    sizingSelector,
    stockStatus,
  });
  const chargerButtonDisabled = useChargerButtonDisabled({
    currentStep,
    isLoadingPdpData,
    size,
    sizingSelector,
  });
  return ringsButtonDisabled || !!chargerButtonDisabled;
};
